// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"71":"04436f94","289":"848dbed5"}[chunkId] + ".css";
};